var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.365
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h14v14H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.62 3.877a3.555 3.555 0 0 0-.779-1.132A3.63 3.63 0 0 0 9.293 1.71c-.674 0-.807.005-1.271.278-.162.095-.899.932-1.022 1.032-.123-.1-.892-.949-1.028-1.032-.327-.2-.59-.278-1.265-.278A3.628 3.628 0 0 0 2.16 2.745a3.533 3.533 0 0 0-1.065 2.526c0 .455.093.93.277 1.412.155.403.376.821.66 1.244.448.669 1.064 1.366 1.83 2.073a20.464 20.464 0 0 0 2.578 2.013l.324.208a.44.44 0 0 0 .472 0l.324-.208A20.728 20.728 0 0 0 10.138 10c.765-.707 1.382-1.404 1.83-2.073.283-.423.506-.84.66-1.244.184-.483.277-.957.277-1.412a3.482 3.482 0 0 0-.286-1.394Z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
};

export { SvgHeart as ReactComponent };
export default __webpack_public_path__ + "614dc91b0af81b60b581e670113cdd1b.svg";